import LoginForm from "../Components/LoginForm";


const LoginPage = () => {
    return(
        <>
        <LoginForm/>
        </>
    )
}

export default LoginPage;